// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CreateOfferingPage {
  width: 100%;
  min-height: 100vh;
  color: #ffffff;
}

.off-create-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.off-create-middle {
  max-width: 100%;
  margin: 0 auto;
  width: 100%;
  box-sizing: border-box;
}

.off-create-header {
  margin-bottom: 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.off-back-btn {
  background: transparent;
  border: 1px solid rgba(72, 209, 204, 0.45);
  border-radius: 20px;
  color: #48d1cc;
  cursor: pointer;
  font-family: 'Inter', sans-serif;
  font-size: 12.5px;
  font-weight: 600;
  padding: 6px 16px;
  width: fit-content;
  transition: all 0.2s ease;
}

.off-back-btn:hover {
  background-color: rgba(72, 209, 204, 0.1);
  border-color: #48d1cc;
}

.off-create-title {
  font-family: 'Inter', sans-serif;
  font-size: 28px;
  font-weight: 800;
  color: #ffffff;
  margin: 0;
  border-left: 4px solid #48d1cc;
  padding-left: 12px;
}

.off-create-loader {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 100px 0;
  color: rgba(255, 255, 255, 0.6);
}

.off-create-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid rgba(72, 209, 204, 0.1);
  border-top-color: #48d1cc;
  border-radius: 50%;
  animation: spinner-spin 0.8s linear infinite;
  margin-bottom: 16px;
}

@keyframes spinner-spin {
  to { transform: rotate(360deg); }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/CreateOfferingPage/CreateOfferingPage.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,0CAA0C;EAC1C,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,yBAAyB;EACzB,kBAAkB;EAClB,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC","sourcesContent":[".CreateOfferingPage {\n  width: 100%;\n  min-height: 100vh;\n  color: #ffffff;\n}\n\n.off-create-container {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n}\n\n.off-create-middle {\n  max-width: 100%;\n  margin: 0 auto;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.off-create-header {\n  margin-bottom: 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.off-back-btn {\n  background: transparent;\n  border: 1px solid rgba(72, 209, 204, 0.45);\n  border-radius: 20px;\n  color: #48d1cc;\n  cursor: pointer;\n  font-family: 'Inter', sans-serif;\n  font-size: 12.5px;\n  font-weight: 600;\n  padding: 6px 16px;\n  width: fit-content;\n  transition: all 0.2s ease;\n}\n\n.off-back-btn:hover {\n  background-color: rgba(72, 209, 204, 0.1);\n  border-color: #48d1cc;\n}\n\n.off-create-title {\n  font-family: 'Inter', sans-serif;\n  font-size: 28px;\n  font-weight: 800;\n  color: #ffffff;\n  margin: 0;\n  border-left: 4px solid #48d1cc;\n  padding-left: 12px;\n}\n\n.off-create-loader {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 100px 0;\n  color: rgba(255, 255, 255, 0.6);\n}\n\n.off-create-spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid rgba(72, 209, 204, 0.1);\n  border-top-color: #48d1cc;\n  border-radius: 50%;\n  animation: spinner-spin 0.8s linear infinite;\n  margin-bottom: 16px;\n}\n\n@keyframes spinner-spin {\n  to { transform: rotate(360deg); }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
